import { useCallback, useContext, useMemo, useState } from "react"
import { REQUESTS_TABS } from ".."
import NavTabs from "src/component/NavTabs/NavTabs"
import { GetRequestsExcel } from "src/requests/Requests"
import { Context } from "src/context"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { checkIfSelectedPharmacy, errorToaster, infoToaster } from "src/utils"
import { useLocation } from "react-router-dom"


type RequestNavTabsProps = {
    selectedTab: number
    setSelectedTab: (tab: number) => void
    disabledTabs: number[]
}

const RequestNavTabs = ({ selectedTab, setSelectedTab, disabledTabs }: RequestNavTabsProps) => {
    const { t } = useTranslation()
    const { state } = useLocation()

    const isHospitalIdSelected = !!Number(sessionStorage.getItem("hopsitalId"))

    const [loadingTabsAction, setLoadingTabsAction] = useState<number | null>(null)

    const { searchData, customSearchData } = useContext(Context)

    const handleDownloadExcel = useCallback((tab: number) => {
        setLoadingTabsAction(tab)
        GetRequestsExcel({ ...searchData, ...customSearchData, }, sessionStorage.getItem("hopsitalId"), tab).then(() => {
            setLoadingTabsAction(null)
        }).finally(() => {
            setLoadingTabsAction(null)
        })
    }, [searchData, customSearchData])

    const requestTabsActions = useMemo(() => {
        return [
            {
                key: REQUESTS_TABS.All,
                action: () => handleDownloadExcel(REQUESTS_TABS.All),
                actionName: "downloadAllExcel",
                icon: loadingTabsAction === REQUESTS_TABS.All ? "line-md:loading-loop" : "vscode-icons:file-type-excel",
                isDisabled: !isHospitalIdSelected || loadingTabsAction === REQUESTS_TABS.All,
                label: "All",
            },
            {
                key: REQUESTS_TABS.Preparing,
                action: () => handleDownloadExcel(REQUESTS_TABS.Preparing),
                actionName: "downloadPreparingExcel",
                icon: loadingTabsAction === REQUESTS_TABS.Preparing ? "line-md:loading-loop" : "vscode-icons:file-type-excel",
                //@ts-ignore
                isDisabled: !isHospitalIdSelected || !customSearchData.pickupId || loadingTabsAction === REQUESTS_TABS.Preparing,
                label: "Preparing",
            },
            {
                key: REQUESTS_TABS.preparedAndReadyForDelivery,
                action: () => handleDownloadExcel(REQUESTS_TABS.preparedAndReadyForDelivery),
                actionName: "downloadPreparedAndReadyForDeliveryExcel",
                icon: loadingTabsAction === REQUESTS_TABS.preparedAndReadyForDelivery ? "line-md:loading-loop" : "vscode-icons:file-type-excel",
                //@ts-ignore
                isDisabled: !isHospitalIdSelected || !customSearchData.pickupId || loadingTabsAction === REQUESTS_TABS.preparedAndReadyForDelivery,
                label: "preparedAndReadyForDelivery",
            },
            {
                key: REQUESTS_TABS.Expired,
                action: () => handleDownloadExcel(REQUESTS_TABS.Expired),
                actionName: "downloadExpiredExcel",
                icon: loadingTabsAction === REQUESTS_TABS.Expired ? "line-md:loading-loop" : "vscode-icons:file-type-excel",
                isDisabled: !isHospitalIdSelected || loadingTabsAction === REQUESTS_TABS.Expired,
                label: "Expired",
            },
        ]
    }, [loadingTabsAction, customSearchData, isHospitalIdSelected, handleDownloadExcel])


    return (
        <div className="mt-5 mb-3 px-2">
            <NavTabs
                selectedTab={selectedTab}
                setSelectedTab={(tab: number) => {
                    if (!checkIfSelectedPharmacy(state)) return infoToaster("please-select-hosptial")
                    setSelectedTab(tab);

                }}
                disabledTabs={disabledTabs}
                tabs={requestTabsActions}
                tabClassName="col-12 col-lg-3"
            />
        </div>
    )
}

export default RequestNavTabs   